import styled from 'styled-components';

export const Wrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;
